import { Container } from "@mui/material";
import TablaCarpetaV2 from "@/components/Tablas/TablaCarpetaV2";
import { TablaCarpetaProvider } from "@/components/Tablas/TablaCarpetaV2/logics/TablaCarritoProvider";
import { ViewAs } from "@/components/Tablas/TablaCarpetaV2/logics/useTablaCarritoV2";
import FiltrosCarpetasAdmin from "@/pages/Dashboard/Pages/Carpetas/CarpetasPage/FiltrosCarpetasAdmin";
import { useContext } from "react";
import { EmpresaContext } from "../VerEmpresasPage";

const CarpetasSection = () => {
  const { empresa } = useContext(EmpresaContext);

  return (
    <Container>
      {empresa?.id && (
        <TablaCarpetaProvider viewAs={ViewAs.ADMIN} isForEmpresa={true}>
          <>
            <FiltrosCarpetasAdmin requiredFields={{ companyId: empresa.id }} />
            <TablaCarpetaV2 />
          </>
        </TablaCarpetaProvider>
      )}
    </Container>
  );
};

export default CarpetasSection;
